/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import { animateScroll as scroll } from "react-scroll";
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)

class StoreLeftMenu extends PureComponent {
  state = {
    show: false,
  };
  _goStore = (store) => {
    //window.open('http://ara1215.ivyro.net/_aniplus/220109/pages/store_info.html', '', '')
    window.scrollTo(0, 0);
    const { history } = this.props;
    history.push('/storeInfo/' + store);
  };
  _goOriginal = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);

    history.push('/storeOriginalGoods');
  };
  _goCollabo = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);

    history.push('/storeCollaboCafe');
  };
  _goLottery = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);

    history.push('/storeLottery');
  };
  _goWrite = () => {
    const { history } = this.props;
    history.push('/storeWrite');
  };
  _goTwitterHome = () => {
    window.open('https://twitter.com/ANIPLUS_SHOP', '', '');
  };
  _store = () => {
    const { history } = this.props;
    history.push('/store');
  };
  _original = () => {
    const { history } = this.props;
    // history.push('/storeOriginalGoods?i=874');
    window.open('https://shop.aniplustv.com', '', '');
  };
  _toggleMenu = () => {
    const { show } = this.state;

    this.setState({
      show: !show,
    });
  };
  render() {
    const { show } = this.state;
    const { loginId, history, imgUrl } = this.props;

    return (
      <Fragment>
        <div
          className={
            show
              ? 'vod_list_left store_left left_naviVisible'
              : 'vod_list_left store_left'
          }
        >
          <button
            type="button"
            className="btn_left_navi"
            title="left menu"
            onClick={this._toggleMenu}
          >
            <i></i>
          </button>
          {/*왼쪽 메뉴 컨트롤용 버튼*/}
          <div className="left_menu_layer">
            {/* <h1>
              <div>
                <div className="slick-slider slick-initialized" dir="ltr">
                  <div className="slick-list">
                    <div className="slick-track">
                      <div
                        data-index="-1"
                        tabIndex="-1"
                        className="slick-slide slick-cloned"
                        aria-hidden="true"
                      >
                        <div>
                          <div
                            onClick={this._original}
                            style={{ cursor: 'pointer' }}
                          >
                            <img src={imgUrl + '/img/store/lnb_top4.png'} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </h1> */}
            <div className="left_menu_group">
              <div className="scrollbar-container ps ps--active-y">
                <div className="left_menu_list">
                  {/* <h3 className="tit">
                    <a onClick={this._store} style={{ cursor: 'pointer' }}>
                      투데이 스토어
                    </a>
                  </h3> */}
                  <div className="left_menu_item">
                    <ul>
                      <li
                        className={
                          history.location.pathname === '/storeInfo/hapjung'
                            ? 'active'
                            : null
                        }
                      >
                        <a
                          onClick={() => this._goStore('hapjung')}
                          style={{ cursor: 'pointer' }}
                        >
                          서울 합정점
                        </a>
                      </li>
                      {/* <li
                        className={
                          history.location.pathname === '/storeInfo/daejeon'
                            ? 'active'
                            : null
                        }
                      >
                        <a
                          onClick={() => this._goStore('daejeon')}
                          style={{ cursor: 'pointer' }}
                        >
                          대전 중앙로점
                        </a>
                      </li>
                      <li
                        className={
                          history.location.pathname === '/storeInfo/gwangju'
                            ? 'active'
                            : null
                        }
                      >
                        <a
                          onClick={() => this._goStore('gwangju')}
                          style={{ cursor: 'pointer' }}
                        >
                          광주 충장로점
                        </a>
                      </li> */}
                      <li
                        className={
                          history.location.pathname === '/storeInfo/busan'
                            ? 'active'
                            : null
                        }
                      >
                        <a
                          onClick={() => this._goStore('busan')}
                          style={{ cursor: 'pointer' }}
                        >
                          부산 서면점
                        </a>
                      </li>
                    </ul>
                    <ul>
                      <li
                        className={
                          history.location.pathname === '/storeCollaboCafe'
                            ? 'active'
                            : null
                        }
                      >
                        <a
                          onClick={this._goCollabo}
                          style={{ cursor: 'pointer' }}
                        >
                          콜라보 카페
                        </a>
                      </li>
                      <li
                        className={
                          history.location.pathname === '/storeOriginalGoods'
                            ? 'active'
                            : null
                        }
                      >
                        <a
                          onClick={this._goOriginal}
                          style={{ cursor: 'pointer' }}
                        >
                          오리지널 굿즈
                        </a>
                      </li>
                      <li
                        className={
                          history.location.pathname === '/storeLottery'
                            ? 'active'
                            : null
                        }
                      >
                        <a
                          onClick={this._goLottery}
                          style={{ cursor: 'pointer' }}
                        >
                          제일 복권
                        </a>
                      </li>
                    </ul>
                    {loginId === 'admin' ||
                    loginId === 'dlrhrjs33' ||
                    loginId === 'lsy7414' ||
                    loginId === 'dooyu63' ||
                    loginId === 'xwuuwx' ||
                    loginId === 'aji311' ||
                    loginId === 'animi15' ||
                    loginId === 'yoonyg00' ? (
                      <ul>
                        <li>
                          <a
                            onClick={this._goWrite}
                            style={{ cursor: 'pointer' }}
                          >
                            글 작성
                          </a>
                        </li>
                      </ul>
                    ) : null}
                  </div>

                  <div className="btm_twt">
                    <a
                      onClick={this._goTwitterHome}
                      style={{ cursor: 'pointer' }}
                    >
                      매장 공식 엑스{' '}
                      <img
                        src={'/img/footer/icon_sns_x.png'}
                        style={{ width: 15, paddingBottom: 4 }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(React.memo(StoreLeftMenu)));
